export const messages = {
  en: {
    repairSetting: {
      queryCondition: 'Query Condition',
      repairTypeNamePlaceholder: 'Please enter type name',
      repairWayPlaceholder: 'Please select dispatch method',
      repairSettingTypePlaceholder: 'Please select repair setting type',
      publicAreaPlaceholder: 'Please select area',
      returnVisitFlagPlaceholder: 'Please select whether to follow up',
      search: 'Search',
      reset: 'Reset',
      repairSettingTitle: 'Repair Settings',
      documentation: 'Documentation',
      add: 'Add',
      typeName: 'Type Name',
      repairSettingType: 'Repair Setting Type',
      dispatchMethod: 'Dispatch Method',
      area: 'Area',
      ownerDisplay: 'Owner Display',
      notificationMethod: 'Notification Method',
      returnVisit: 'Return Visit',
      processingTime: 'Processing Time (hours)',
      timeoutWarning: 'Timeout Warning (minutes)',
      createTime: 'Create Time',
      operation: 'Operation',
      edit: 'Edit',
      bindRepairMaster: 'Bind Repair Master',
      delete: 'Delete',
      explanation: 'Explanation',
      save: 'Save',
      cancel: 'Cancel',
      confirmDeleteTitle: 'Please confirm your operation!',
      confirmDeleteContent: 'Are you sure to delete this repair setting?',
      cancelDelete: 'Cancel',
      confirmDelete: 'Confirm Delete',
      addTitle: 'Add Repair Setting',
      editTitle: 'Edit Repair Setting',
      settingType: 'Setting Type',
      publicArea: 'Public Area',
      ownerDisplayPlaceholder: 'Whether to display in owner app',
      notificationMethodPlaceholder: 'Please select notification method',
      returnVisitSetting: 'Return Visit Setting',
      remarkPlaceholder: 'Optional, please enter remarks',
      required: 'Required',
      cleaningOrder: 'Cleaning Order',
      repairOrder: 'Repair Order',
      grabOrder: 'Grab Order',
      assign: 'Assign',
      polling: 'Polling',
      nonHouse: 'Non-House',
      house: 'House',
      yes: 'Yes',
      no: 'No',
      sms: 'SMS',
      wechat: 'WeChat',
      wechatWorkLicense: 'WeChat + Employee License',
      noFollowUp: 'No Follow Up',
      followUpAfterEvaluation: 'Follow Up After Evaluation',
      followUp: 'Follow Up',
      dispatchExplanation: 'Dispatch Explanation:',
      dispatchPoint1: '1. Grab Order: Employees (masters under the repair type) grab orders independently, suitable for scenarios where the property gives commissions per order',
      dispatchPoint2: '2. Assign: Specifically assigned by customer service to employees (masters under the repair type)',
      dispatchPoint3: '3. Polling: System periodically assigns orders to employees (masters under the repair type)',
      areaExplanation: 'Area Explanation:',
      areaPoint1: 'Community, building, unit are non-house areas; houses are house areas',
      areaPoint2: 'Note: For owner house repairs, a house area type must be added for normal repair',
      processingTimeUnit: 'Hours',
      timeoutWarningUnit: 'Minutes'
    }
  },
  zh: {
    repairSetting: {
      queryCondition: '查询条件',
      repairTypeNamePlaceholder: '请输入类型名称',
      repairWayPlaceholder: '请选择派单方式',
      repairSettingTypePlaceholder: '请选择报修设置类型',
      publicAreaPlaceholder: '请选择区域',
      returnVisitFlagPlaceholder: '请选择是否回访',
      search: '查询',
      reset: '重置',
      repairSettingTitle: '报修设置',
      documentation: '文档',
      add: '添加',
      typeName: '类型名称',
      repairSettingType: '报修设置类型',
      dispatchMethod: '派单方式',
      area: '区域',
      ownerDisplay: '业主端展示',
      notificationMethod: '通知方式',
      returnVisit: '是否回访',
      processingTime: '办理时长',
      timeoutWarning: '超时预警',
      createTime: '创建时间',
      operation: '操作',
      edit: '修改',
      bindRepairMaster: '绑定维修师傅',
      delete: '删除',
      explanation: '说明',
      save: '保存',
      cancel: '取消',
      confirmDeleteTitle: '请确认您的操作!',
      confirmDeleteContent: '确定删除报修设置',
      cancelDelete: '点错了',
      confirmDelete: '确认删除',
      addTitle: '添加报修设置',
      editTitle: '修改报修设置',
      settingType: '设置类型',
      publicArea: '公共区域',
      ownerDisplayPlaceholder: '必填，请选择是否在业主端展示',
      notificationMethodPlaceholder: '必填，请选择通知方式',
      returnVisitSetting: '回访设置',
      remarkPlaceholder: '选填，请填写说明',
      required: '必填',
      cleaningOrder: '保洁单',
      repairOrder: '维修单',
      grabOrder: '抢单',
      assign: '指派',
      polling: '轮训',
      nonHouse: '非房屋',
      house: '房屋',
      yes: '是',
      no: '否',
      sms: '短信',
      wechat: '微信',
      wechatWorkLicense: '微信+员工工牌',
      noFollowUp: '不回访',
      followUpAfterEvaluation: '已评价不回访',
      followUp: '回访',
      dispatchExplanation: '派单方式说明：',
      dispatchPoint1: '1、抢单：员工（报修类型下的师傅）自主抢单维修处理，比较实用于物业每单给维修是否提成的场景',
      dispatchPoint2: '2、指派：专门由客服派单员工（报修类型下的师傅）维修处理，一般物业的选择',
      dispatchPoint3: '3、轮训：由系统定时派单员工（报修类型下的师傅）维修处理',
      areaExplanation: '区域说明：',
      areaPoint1: '小区、楼栋、单元为非房屋类区域，房屋为房屋类区域',
      areaPoint2: '注意：一般业主房屋报修必须添加一个房屋类区域的类型才能正常报修',
      processingTimeUnit: '小时',
      timeoutWarningUnit: '分钟'
    }
  }
}